import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import userService from '../../services/userService';
import {userStateType} from '../../types/types';

export const getAffiliateCode = createAsyncThunk(
  'code/getAffiliateCode',
  async () => {
    const response = await userService.getAffiliateCode();
    return response;
  },
);

const initialState: userStateType = {
  code: null,
  error: null,
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAffiliateCode.fulfilled, (state, action) => {
      state.code = action.payload; // action.payload.content
    });
    builder.addCase(getAffiliateCode.rejected, (state, action) => {
      state.error = action.payload;
    });
    builder.addCase(getAffiliateCode.pending, (state, action) => {
      state.error = null;
      state.code = null;
    });
  },
});

export default userSlice.reducer;
